<template>
  <div class="h-100">
    <CRow class="h-100">
      <CCol class="h-100 px-2">
        <CCard :accent-color="zoningId ? 'info' : 'success'" class="h-100 card-scroll-y">
          <CCardHeader class="px-3">
            <CRow>
              <CCol col="8">
                <h4 class="text-uppercase mb-0 mt-1" v-if="zoningId">
                  <router-link to="/zoning">
                    <CIcon name="cil-arrow-circle-left" class="mt-0 mb-1 mr-1 x2"></CIcon>
                  </router-link>
                  Sửa tin quy hoạch
                </h4>
                <h4 class="text-uppercase mb-0" v-else>
                  <router-link to="/zoning">
                    <CIcon name="cil-arrow-circle-left" class="mt-0 mb-1 mr-1 x2"></CIcon>
                  </router-link>
                  Đăng tin quy hoạch
                </h4>
              </CCol>
              <CCol col="4" class="float-right" v-if="zoningId">
                <CRow>
                  <CCol :col="{size: 8, offset: 4}">
                    <CRow>
                      <CCol col="6">
                        <CButton block color="dark">Ẩn tin</CButton>
                      </CCol>
                      <CCol col="6">
                        <CButton block color="danger">Xóa tin</CButton>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody class="p-3">
            <CRow class="h-100">
              <CCol md="6">
                <CCard :border-color="zoningId ? 'success': 'info'" class="mb-3">
                  <CCardHeader class="px-3 font-weight-bold">
                    <CIcon name="cil-pen-alt"/>
                    Thông tin
                    <b-form-checkbox switch class="float-right" v-model="formData.isHighlight">Bài đăng nổi bật
                    </b-form-checkbox>
                  </CCardHeader>
                  <CCardBody class="p-3">
                    <div v-for="(item, index) in dataSelectInit" :key="index" class="m-0 p-0">
                      <hr v-if="dataSelectInit.length && item.key === 'divider'"/>
                      <CRow class="mb-2"
                            v-if="item.key !== 'divider' && ((item.key === 'zoning_types') || (item.key === 'provinces' ? true : (item.key === 'districts' ? formData.provinceId !== -1 : (formData.provinceId !== -1 && formData.districtId !== -1))))">
                        <CCol col="3">
                          <label class="mb-0 mt-1">{{ item.itemName }}</label>
                        </CCol>
                        <CCol col="9">
                          <ModelListSelect class="select-with-search"
                                             :list="item.key === 'zoning_types' ? zoneTypeList : (item.key === 'provinces' ? provinceList : (item.key === 'districts' ? districtList : communeList))"
                                             v-model="formData[item.model]" option-value="id"
                                             option-text="name"
                                             @input="modelListSltChange($event, item.key)"></ModelListSelect>
                        </CCol>
                      </CRow>
                    </div>

                    <hr/>

                    <CRow class="mb-2">
                      <CCol col="3">
                        <label class="mb-0 mt-1">Tiêu đề</label>
                      </CCol>
                      <CCol col="9">
                        <b-form-input v-model="formData.title" placeholder="Nhập tiêu đề tin..."></b-form-input>
                      </CCol>
                    </CRow>
                    <CRow class="mb-2">
                      <CCol col="3">
                        <label class="mb-0 mt-1">Ảnh tiêu đề</label>
                      </CCol>
                      <CCol col="9">
                        <div
                          v-if="titleImageUploader.src"
                          class="gallery">
                          <img
                            :src="titleImageUploader.src"
                            alt="Cinque Terre" width="600" height="600">
                          <CProgress
                            v-if="titleImageUploader.percent!==100"
                            :value="titleImageUploader.percent"
                            color="success"
                            animated
                            show-value
                            style="
                          margin: 10px;
                          height:10px;"
                          />
                        </div>

                        <b-form-file
                          ref="titleImage"
                          accept="image/*"
                          @change="onChangeTitleImage"></b-form-file>
                      </CCol>

                    </CRow>
                    <CRow class="mb-2">
                      <CCol col="3">
                        <label class="mb-0">Mô tả ngắn</label>
                      </CCol>
                      <CCol col="9">
                        <quill-editor class="editor-preview" v-model="formData.preview"></quill-editor>
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol col="3">
                        <label class="mb-0">Nội dung</label>
                      </CCol>
                      <CCol col="9">
                        <quill-editor class="editor-description" v-model="formData.description"></quill-editor>
                      </CCol>
                    </CRow>

                    <hr/>

                    <CRow class="mb-2">
                      <CCol col="3">
                        <label class="mb-0 mt-1">Ảnh bài viết</label>
                      </CCol>
                      <CCol col="9">
                        <b-form-file
                          multiple
                          accept="image/*"
                          @change="onChangeHeaderImage"></b-form-file>
                      </CCol>
                    </CRow>
                    <CRow class="mb-2 grid-container">
                      <div class="gallery"
                           :key="image.name"
                           v-for="image in formData.headers">
                        <img :src="image.src"
                             alt="Cinque Terre" width="600" height="400">
                        <div class="desc">{{ image.status }}</div>
                        <CProgress
                          :value="image.percent"
                          color="success"
                          animated
                          show-value
                          style="
                          margin: 0 0 20px 0;
                          height:10px;"
                        />
                      </div>
                    </CRow>

                    <hr/>

                    <CRow class="mb-2">
                      <CCol col="3">
                        <label class="mb-0 mt-1">Ảnh cuối bài viết</label>
                      </CCol>
                      <CCol col="9">
                        <b-form-file
                          multiple
                          accept="image/*"
                          @change="onChangeFooterImage"></b-form-file>
                      </CCol>
                    </CRow>
                    <CRow class="mb-2 grid-container">
                      <div class="gallery"
                           :key="image.name"
                           v-for="image in formData.footers">
                        <img :src="image.src"
                             alt="Cinque Terre" width="600" height="400">
                        <div class="desc">{{ image.status }}</div>
                        <CProgress
                          :value="image.percent"
                          color="success"
                          animated
                          show-value
                          style="
                          margin: 0 0 20px 0;
                          height:10px;"
                        />
                      </div>
                    </CRow>
                  </CCardBody>
                </CCard>
              </CCol>
              <CCol md="6" class="h-100">
                <CCard border-color="danger" class="h-100 card-scroll-y">
                  <CCardHeader class="px-3 font-weight-bold">
                    <CIcon name="cil-map"/>
                    Bản đồ
                  </CCardHeader>
                  <CCardBody class="p-3 d-flex flex-column">
                    <CRow>
                      <CCol col="5" class="gmap-place-input">
                        <gmap-autocomplete placeholder="Nhập vị trí cần tìm..." class="form-control"
                                           @place_changed="setPlace"
                                           :options="{fields: ['geometry', 'formatted_address', 'address_components']}"></gmap-autocomplete>
                      </CCol>
                      <CCol col="7">
                        <b-form-file v-model="formData.imageFile" ref="imageFileInput" accept="image/*, .mbtiles"
                                     @change="onChangeMapFile"></b-form-file>
                      </CCol>
                    </CRow>
                    <CRow class="h-100 mt-2">
                      <CCol>
                        <gmap-map
                          ref="map"
                          class="w-100 h-100"
                          :center="formData.mapInfo.center"
                          :zoom="formData.mapInfo.zoom"
                          :options="optionsGMap"
                        >
                          <custom-overlay-view
                            ref="customOverlayView"
                            v-if="formData.mapInfo.imageOverlay.src"
                            :position="formData.mapInfo.imageOverlay.position"
                            :initBounds="formData.mapInfo.imageOverlay.initBounds"
                            :size="formData.mapInfo.imageOverlay.size"
                            :style="{
                              opacity: formData.mapInfo.imageOverlay.opacity,
                              transform: `rotate(${formData.mapInfo.imageOverlay.rotate}deg)`,
                              '-webkit-transform' : `rotate(${formData.mapInfo.imageOverlay.rotate}deg)`,
                              '-moz-transform' : `rotate(${formData.mapInfo.imageOverlay.rotate}deg)`,
                              '-o-transform': `rotate(${formData.mapInfo.imageOverlay.rotate}deg)`,
                              '-ms-transform': `rotate(${formData.mapInfo.imageOverlay.rotate}deg)`,
                              border: '1px dotted #333'
                             }">
                            <b-img id="imageOverlay" :src="formData.mapInfo.imageOverlay.src"
                                   class="image-overlay-map"></b-img>
                            <div id="resizeA" style="cursor: se-resize;left: -6px;top: -6px;"
                                 class="resize-image-overlay"></div>
                            <div id="resizeB" style="cursor: sw-resize;right: -6px;top: -6px;"
                                 class="resize-image-overlay"></div>
                            <div id="resizeC" style="cursor: se-resize;right: -6px;bottom: -6px;"
                                 class="resize-image-overlay"></div>
                            <div id="resizeD" style="cursor: sw-resize;left: -6px;bottom: -6px;"
                                 class="resize-image-overlay"></div>
                          </custom-overlay-view>
                        </gmap-map>
                      </CCol>
                      <div
                        v-if="this.mapUploader.status==='uploading'"
                        style="
                        width: 100%;
                        height: 100%;
                        position:absolute;">
                        <div style="
                        width: 100%;
                        height: 100%;
                        background: white;
                        opacity: 0.8">
                        </div>

                        <div style="
                        position:absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%">
                          <p style="margin: 100px 0 20px 20px">{{ mapUploader.name }}</p>
                          <CProgress
                            :value="mapUploader.percent"
                            color="success"
                            animated
                            show-value
                            style="
                            margin: 20px;
                            height:20px;"
                          />
                        </div>


                      </div>

                    </CRow>
                  </CCardBody>
                  <CCardFooter class="px-3" v-if="formData.mapInfo.imageOverlay.src">
                    <CRow>
                      <CCol col="6">
                        <CRow>
                          <CCol col="3">
                            <label class="mb-0 align-middle">Xoay ảnh</label>
                          </CCol>
                          <CCol col="6">
                            <b-form-input type="range" min="-360" max="360"
                                          v-model="formData.mapInfo.imageOverlay.rotate" class="align-middle"
                                          style="padding-top: 3px"></b-form-input>
                          </CCol>
                          <CCol col="3">
                            <b-form-input type="number" v-model="formData.mapInfo.imageOverlay.rotate" size="sm"
                                          class="font-weight-bold"></b-form-input>
                          </CCol>
                        </CRow>
                      </CCol>
                      <CCol col="6" style="border-left: 1px solid #d8dbe0">
                        <CRow>
                          <CCol col="3">
                            <label class="mb-0 align-middle">Độ mờ</label>
                          </CCol>
                          <CCol col="6">
                            <b-form-input type="range" min="0" max="1" step="0.1"
                                          v-model="formData.mapInfo.imageOverlay.opacity" class="align-middle"
                                          style="padding-top: 2px"></b-form-input>
                          </CCol>
                          <CCol col="3">
                            <b-form-input type="number" step="0.1" v-model="formData.mapInfo.imageOverlay.opacity"
                                          size="sm" class="font-weight-bold"></b-form-input>
                          </CCol>
                        </CRow>
                      </CCol>
                    </CRow>
                  </CCardFooter>
                </CCard>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="px-3">
            <CRow>
              <CCol :col="{ size: 4, offset: 8 }" class="float-right">
                <CRow>
                  <CCol :col="{ size: 4, offset: 8 }">
                    <CButton block color="info" v-if="zoningId">Cập nhật</CButton>
                    <CButton block color="success" v-else @click="newAction">Thêm mới</CButton>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import WebApiUtil from '@/common/webApiUtil'
import apiUrl from '@/common/apiUrl'
import CustomOverlayView from "@/components/zoning/CustomOverlayView"
import * as _ from 'lodash'
import {COMMON} from '@/common/Constant'
import {format} from '@/mixins/format'
import {storage} from '@/main'
import {SHOW_TOAST_2} from '@/common/lib'
import {ModelListSelect} from 'vue-search-select'
import {mapActions} from 'vuex'

export default {
  name: 'CreateOrUpdate',
  mixins: [
    format
  ],
  components: {
    CustomOverlayView,
    ModelListSelect
  },
  data() {
    return {
      dataSelectInit: COMMON.dataSelectInitZoningCreateOrUpdate,
      selectOptionNull: {
        id: -1,
        name: '-- Chọn giá trị --'
      },
      provinceList: [],
      districtList: [],
      communeList: [],
      zoneTypeList: [],
      zoningId: null,
      googleMapDarkStyles: [
        {elementType: 'geometry', stylers: [{color: '#242f3e'}]},
        {
          elementType: 'labels.text.stroke',
          stylers: [{color: '#242f3e'}],
        },
        {elementType: 'labels.text.fill', stylers: [{color: '#746855'}]},
        {
          featureType: 'administrative.locality',
          elementType: 'labels.text.fill',
          stylers: [{color: '#d59563'}],
        },
        {
          featureType: 'poi',
          elementType: 'labels.text.fill',
          stylers: [{color: '#d59563'}],
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [{color: '#263c3f'}],
        },
        {
          featureType: 'poi.park',
          elementType: 'labels.text.fill',
          stylers: [{color: '#6b9a76'}],
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [{color: '#38414e'}],
        },
        {
          featureType: 'road',
          elementType: 'geometry.stroke',
          stylers: [{color: '#212a37'}],
        },
        {
          featureType: 'road',
          elementType: 'labels.text.fill',
          stylers: [{color: '#9ca5b3'}],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [{color: '#746855'}],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.stroke',
          stylers: [{color: '#1f2835'}],
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.fill',
          stylers: [{color: '#f3d19c'}],
        },
        {
          featureType: 'transit',
          elementType: 'geometry',
          stylers: [{color: '#2f3948'}],
        },
        {
          featureType: 'transit.station',
          elementType: 'labels.text.fill',
          stylers: [{color: '#d59563'}],
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [{color: '#17263c'}],
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [{color: '#515c6d'}],
        },
        {
          featureType: 'water',
          elementType: 'labels.text.stroke',
          stylers: [{color: '#17263c'}],
        },
      ],
      optionsGMap: {
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: true,
        streetViewControl: true,
        rotateControl: true,
        fullscreenControl: true,
        disableDefaultUi: false,
      },
      formData: {
        isHighlight: true,
        zoneTypeId: -1,
        provinceId: -1,
        districtId: -1,
        communeId: -1,
        title: '',
        preview: '',
        description: '',
        imageFile: null,
        mapInfo: {
          // Default: Hoan Kiem Lake - Hanoi
          center: {
            lat: 21.0287797, lng: 105.850176
          },
          zoom: 16,
          imageOverlay: {
            initBounds: null,
            src: null,
            size: {width: 0, height: 0},
            position: {},
            opacity: 1,
            rotate: 0,
            url: ''
          }
        },
        headers: [],
        footers: [],
      },
      titleImageUploader: {},
      mapUploader: {},
    }
  },
  async created() {
    await Promise.all([
      this.provinceList.push(this.selectOptionNull),
      this.districtList.push(this.selectOptionNull),
      this.communeList.push(this.selectOptionNull),
      this.zoneTypeList.push(this.selectOptionNull)
    ])
    await this.initData()
    this.zoningId = this.$route.params.zoningId
  },
  async mounted() {
    await this.getLocationAndZoneTypeList()
    this.provinceList = _.concat([this.selectOptionNull], JSON.parse(localStorage.getItem('provinceList')))
    this.zoneTypeList = _.concat([this.selectOptionNull], JSON.parse(localStorage.getItem('zoneTypeList')))
  },
  methods: {
    ...mapActions('common', ['getLocationAndZoneTypeList']),
    async setPlace(place) {
      const _place = place
      if (_place) {
        this.formData.mapInfo.center.lat = _place.geometry.location.lat()
        this.formData.mapInfo.center.lng = _place.geometry.location.lng()

        await this.initData()
        this.formData.imageFile = null
        this.formData.mapInfo.imageOverlay.src = null
      }
    },
    async newAction() {
      let body = this.createBody()
      let result = await WebApiUtil.post(apiUrl.zoneCreate, body)

      if (result.data.status === 0) {
        SHOW_TOAST_2('info', 'Đăng tin thành công')
        await this.$router.push({name: 'Zoning'})
      } else
        SHOW_TOAST_2('error', 'Đăng tin thất bại: ')
    },
    createBody() {
      let overlayData;
      let overlayView = this.$refs.customOverlayView
      if (overlayView != null) {
        overlayData = overlayView.getOverlayData()
      } else {
        overlayData = {
          zoom: 15,
          position: {lat: 0, lng: 0},
          bounds: {
            sw: {lat: 0, lng: 0},
            ne: {lat: 0, lng: 0}
          },
        }
      }
      let overlays
      if (this.formData.mapInfo.imageOverlay.url) {
        overlays = [
          {
            "imageUrl": this.formData.mapInfo.imageOverlay.url,
            "rotate": this.formData.mapInfo.imageOverlay.rotate,
            "bounds": overlayData.bounds
          }
        ]
      } else {
        overlays = []
      }
      let header_data = []
      for (let i = 0, len = this.formData.headers.length; i < len; i++) {
        header_data.push(this.formData.headers[i].url)
      }
      let footer_data = []
      for (let i = 0, len = this.formData.footers.length; i < len; i++) {
        footer_data.push(this.formData.footers[i].url)
      }

      return {
        "province_id": this.formData.provinceId,
        "district_id": this.formData.districtId,
        "commune_id": this.formData.communeId,
        "zoning_type_Id": this.formData.zoneTypeId,
        "title": this.formData.title,
        "description": this.formData.preview,
        "body": this.formData.description,
        "map": {
          "zoom": overlayData.zoom,
          "location": overlayData.position,
          "overlays": overlays
        },
        "map_image_url": this.titleImageUploader.url,
        // "view_price": 2,
        "news_type": 1, //1 tin tuc admin, 2 quy hoach
        "is_highlight": this.formData.isHighlight ? 2 : 1,
        "header_data": header_data,
        "footer_data": footer_data
      }
    },
    initData() {
      const _mapInfo = this.formData.mapInfo
      _.merge(_mapInfo.imageOverlay.position, _mapInfo.center)
    },
    async onChangeMapFile(e) {
      if (e.target.files.length === 0 || !e.target.files) return
      const file = e.target.files[0]
      if (!file) return

      this.mapUploader = this.createUploader(file)
      // let result = await WebApiUtil.upload(file)
      let result = await this.uploadToFirebaseStorage(this.mapUploader)
      if (!result) {
        return
      }

      this.formData.mapInfo.imageOverlay.url = result
      let _URL = URL || window.webkitURL

      let loader = new Image()

      let self = this
      loader.onload = function () {
        /* todo detail set
            let b = {
              sw: {lat: 12.70635912812659, lng: 108.07241754982911},
              ne: {lat: 12.717353174766838, lng: 108.08735408394779}
            }
            self.formData.mapInfo.imageOverlay.initBounds = b
            self.formData.mapInfo.zoom = 15
            self.formData.mapInfo.center = {lat: (b.sw.lat + b.ne.lat) / 2, lng: (b.sw.lng + b.ne.lng) / 2}
            */
        self.formData.mapInfo.imageOverlay.src = _URL.createObjectURL(file)
        self.formData.mapInfo.imageOverlay.size = {width: this.width, height: this.height}
      }

      loader.src = _URL.createObjectURL(file)
    },
    async onChangeTitleImage(e) {
      const files = e.target.files
      if (files.length === 0 || !files) return
      const file = files[0]
      if (!file) return

      this.titleImageUploader = this.createUploader(file)
      await this.uploadToFirebaseStorage(this.titleImageUploader)
    },
    onChangeHeaderImage(e) {
      const files = e.target.files
      if (files.length === 0 || !files) return

      // this.formData.headers = []
      for (let i = 0; i < files.length; i++) {
        let uploader = this.createUploader(files[i])
        this.formData.headers.push(uploader)
        this.uploadToFirebaseStorage(uploader)
      }
    },
    onChangeFooterImage(e) {
      const files = e.target.files
      if (files.length === 0 || !files) return

      // this.formData.footers = []
      for (let i = 0; i < files.length; i++) {
        let uploader = this.createUploader(files[i])
        this.formData.footers.push(uploader)
        this.uploadToFirebaseStorage(uploader)
      }
    },
    createUploader(file) {
      let _URL = URL || window.webkitURL
      return {
        show: true,
        file: file,
        name: file?.name || null,
        percent: 0,
        src: _URL.createObjectURL(file),
        url: '',
        status: 'ready',
        error: ''
      }
    },
    uploadToFirebaseStorage(uploader) {
      return new Promise((resolve, reject) => {
        let ext = this.re.exec(uploader.name)[1];
        let name = this.randomString() + "." + ext
        const imageStorageRef = storage.ref('admin/' + name);
        imageStorageRef.put(uploader.file).on('state_changed', snapshot => {
            uploader.status = "uploading";
            uploader.percent = (snapshot.bytesTransferred / snapshot.totalBytes) * 99;
          }, error => {
            uploader.status = "error";
            uploader.error = error;
            reject(error);
          }, async () => {
            uploader.url = await imageStorageRef.getDownloadURL()
            uploader.percent = 100;
            uploader.status = "success";
            resolve(uploader.url);
          }
        );
      })
    },
    tempFile(name = 'temp_file', data = '', encoding = 'utf8') {
      const fs = require('fs');
      const os = require('os');
      const path = require('path');

      return new Promise((resolve, reject) => {
        const tempPath = path.join(os.tmpdir(), 'foobar-');
        fs.mkdtemp(tempPath, (err, folder) => {
          if (err) return reject(err)
          const file_name = path.join(folder, name);
          fs.writeFile(file_name, data, encoding, error_file => {
            if (error_file)
              return reject(error_file);
            resolve(file_name)
          })
        })
      })
    },
    modelListSltChange(_value, type) {
      if (_value) {
        if (_value !== -1) {
          if (type === 'provinces') {
            this.districtList = _.concat([this.selectOptionNull], JSON.parse(localStorage.getItem('districtList')).filter(item => item['province_id'] === _value))
          } else if (type === 'districts') {
            this.communeList = _.concat([this.selectOptionNull], JSON.parse(localStorage.getItem('communeList')).filter(item => item['district_id'] === _value))
          }
        } else {
          if (type === 'provinces') {
            this.districtList = [this.selectOptionNull]
          } else if (type === 'districts') {
            this.communeList = [this.selectOptionNull]
          }
        }
      }
    }
  },
  computed: {
    provinceIdValue() {
      return this.formData.provinceId
    },
    districtIdValue() {
      return this.formData.districtId
    }
  },
  watch: {
    provinceIdValue(value) {
      if (value) {
        this.formData.districtId = -1
        this.formData.communeId = -1
      }
    },
    districtIdValue(value) {
      if (value) {
        this.formData.communeId = -1
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.gmap-place-input {
  label {
    width: 100% !important;
  }
}

div.gallery {
  margin: 5px;
  border: 1px solid #ccc;
  float: left;
  width: 180px;
}

div.gallery:hover {
  border: 1px solid #777;
}

div.gallery img {
  width: 100%;
  height: auto;
}

div.desc {
  padding: 15px 0 0 0;
  text-align: center;
}
</style>
